<template>
  <modal ref="securityModal" id="security-modal" anchor="#templateSecurity" centered hide-header content-class="securityModalRectangle">
    <template #default>
      <span class="Masthead">Security settings</span>
      <div class="security-settings">
        <rails-b-form ref="securityForm">
          <template v-if="!personalOrg">
            <p class="Byline">Who can access this link?</p>
            <b-form-group>
              <b-form-radio v-model="securitySetting" name="security_setting" value="un" selected>Anyone with the link</b-form-radio>
              <b-form-radio v-model="securitySetting" name="security_setting" value="og">Anyone in your organization</b-form-radio>
            </b-form-group>
          </template>

          <div class="d-flex checkbox">
            <label for="expire_days_enabled">Automatically expire</label>
            <b-form-checkbox switch v-model="expireDaysEnabled" name="expire_days_enabled" :value="true" :unchecked-value="false"/>
          </div>

          <b-form-group v-if="expireDaysEnabled">
            <b-container fluid>
              <b-row align-h="start" no-gutters>
                <b-col>After</b-col>
                <b-col><b-form-input size="sm" v-model="expireDays" type="number"/></b-col>
                <b-col>days</b-col>
              </b-row>
            </b-container>
          </b-form-group>
        </rails-b-form>
      </div>
    </template>

    <template #modal-footer="">
      <b-button @click="submitForm()" class="mt-2" variant="primary" block>Save</b-button>
      <b-button @click="$bvModal.hide('security-modal')" variant="outline-secondary" block>Cancel</b-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/src/components/modal';
import RailsBForm from '@/src/components/rails_b_form.vue';

export default {
  components: { RailsBForm, Modal },
  props: [ "settings" ],
  computed: {
    personalOrg: function() {
      return this.$store.state.currentOrganization?.attributes?.personal;
    }
  },
  watch: {
    settings: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.expireDaysEnabled = value.expireDaysEnabled || false;
        this.expireDays = value.expireDays || 7;
        this.securitySetting = value.securitySetting || "un";
      }
    }
  },
  methods: {
    submitForm: function() {
      this.$emit("selectSecuritySettings", {
        expireDaysEnabled: this.expireDaysEnabled,
        expireDays: this.expireDays,
        securitySetting: this.securitySetting
      });
      this.$bvModal.hide('security-modal');
    }
  },
  data: function() {
    return {
      expireDaysEnabled: this.settings.expireDaysEnabled, 
      expireDays: this.settings.expireDays,
      securitySetting: this.settings.securitySetting // 'un' for unrestricted or 'og' for organizatino
    }
  }
}
</script>

<style lang="scss">
@import '@/packs/application.scss';

.modal-content.securityModalRectangle {
  padding: 0.6rem 1rem;
  border-radius: 16px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
  border: solid 0.5px #b5b5b5;
  background-color: $white;
}

.modal-body {
  height: 100%;
}
</style>

<style lang="scss" scoped>
@import '@/packs/application.scss';

.Masthead {
  width: 14.25rem;
  height: 2.375rem;
  font-family: SFPro;
  font-size: 2rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.Byline {
  margin: 1rem 1rem 1rem 0;
  font-family: SFPro;
  font-size: 0.9rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.Byline-Copy {
  width: 8.688rem;
  height: 1.5rem;
  margin: 1rem 1rem 1rem 0;
  font-family: SFPro;
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.Combined-Shape {
  width: 2rem;
  height: 2rem;
  margin: 0 1.125rem 0 0;
  background-image: linear-gradient(340deg, #24d292 92%, #d558c8 9%);
}

.security-settings {
  position: relative;
  overflow-y: visible;
  overflow-x: hidden;
  vertical-align: middle;
}

.checkbox {
  margin-right: 30%;

  label {
    flex-grow: 1;
  }
}
</style>
